<template>
  <p ref="root" class="counter">{{ display }}{{ suffix }}</p>
</template>

<script>
// Counts up to `value` the first time it scrolls into view.

export default {
  name: 'SiteCounter',

  props: {
    value: { type: Number, required: true },
    suffix: { type: String, default: '' },
    duration: { type: Number, default: 1600 },
  },

  data() {
    return { display: 0 }
  },

  mounted() {
    this.observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return
      this.observer.disconnect()
      this.run()
    })
    this.observer.observe(this.$refs.root)
  },

  beforeUnmount() {
    if (this.observer) this.observer.disconnect()
    if (this.frame) cancelAnimationFrame(this.frame)
  },

  methods: {
    run() {
      const start = performance.now()

      const tick = (now) => {
        const progress = Math.min((now - start) / this.duration, 1)
        // ease-out, so the number slows down as it lands
        this.display = Math.round(this.value * (1 - Math.pow(1 - progress, 3)))
        if (progress < 1) this.frame = requestAnimationFrame(tick)
      }

      this.frame = requestAnimationFrame(tick)
    },
  },
}
</script>

<style scoped>
.counter {
  font-size: 130px;
  line-height: 1.6;
}

@media (max-width: 767px) {
  .counter {
    font-size: 72px;
  }
}
</style>
